export default function NasilKullanilir() {
    return (
      <>
        <div className="row">
          <div className="col text-center mt-5">
            <h1 className="text-danger">Nasıl Kullanılır?</h1>
          </div>
        </div>
        <div className="row">
          <div className="row">
            <div className="col justify-content-center mt-5">
              <h2>
                Adım 1) Öncelikle taşınmaz değerlemesinde kullanılacak resmi
                veriler "Münavebe Kaydet" sekmesinden kaydedilir.
              </h2>
              <img
                src={require("../images/munavebekaydet.jpg")}
                style={{ height: "50vh" }}
                alt=""
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="row">
            <div className="col text-center mt-5">
              <h2>
                Adım 2) Taraf avukatları kaydedilir. Sıklıkla kullanılan avukat
                isimleri resimdeki gibi eklenir.
              </h2>
              <img
                src={require("../images/avukatkayit.jpg")}
                style={{ height: "30vh" }}
                alt=""
              />
            </div>
          </div>
        </div>
        <hr />

        <div className="row">
          <div className="row">
            <div className="col text-center mt-5">
              <h2>
                Adım 3) Bilirkişi bilgileri kayıt edilir. Sıklıkla beraber
                çalışılan bilirkişi bilgileri resimdeki gibi eklenir.
              </h2>
              <img
                src={require("../images/bilirkisikayit.jpg")}
                style={{ height: "40vh" }}
                alt=""
              />
            </div>
          </div>
        </div>
      </>
    );
}
